import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useCRM } from '../context/CRMContext';
import { ArrowLeft, Calendar, DollarSign, Building, User, Tag, Info, CheckSquare, XSquare } from 'lucide-react';

const LeadDetail: React.FC = () => {
  const { leadId } = useParams<{ leadId: string }>();
  const navigate = useNavigate();
  const { opportunities } = useCRM();

  const lead = opportunities.find(op => op.id === leadId);

  if (!lead) {
    return <div>Lead not found</div>;
  }

  const DetailItem = ({ icon: Icon, label, value }: { icon: React.ElementType, label: string, value: React.ReactNode }) => (
    <div className="grid grid-cols-3 gap-4 py-2 border-b border-gray-100">
      <dt className="text-sm font-medium text-gray-500 flex items-center"><Icon className="w-4 h-4 mr-2 text-gray-400" />{label}</dt>
      <dd className="mt-1 text-sm text-gray-900 col-span-2">{value || 'N/A'}</dd>
    </div>
  );

  return (
    <div className="bg-gray-50 p-6 h-full overflow-y-auto">
      <div className="flex items-center mb-6">
        <button onClick={() => navigate(-1)} className="p-2 rounded-full hover:bg-gray-200 mr-4">
          <ArrowLeft size={20} />
        </button>
        <h1 className="text-2xl font-bold text-gray-800 mr-4">{lead.contactName}</h1>
        <span className={`px-3 py-1 text-xs font-semibold rounded-full bg-blue-100 text-blue-800`}>{lead.dealStage}</span>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2 bg-white p-6 rounded-lg shadow-sm">
          <h2 className="text-lg font-semibold text-gray-900 mb-4">Lead Information</h2>
          <dl>
            <DetailItem icon={Building} label="Company" value={lead.companyName} />
            <DetailItem icon={User} label="Contact Name" value={lead.contactName} />
            <DetailItem icon={User} label="Sales Rep" value={lead.salesRep} />
            <DetailItem icon={DollarSign} label="Deal Size" value={lead.expectedDealSize} />
            <DetailItem icon={Tag} label="Deal Type" value={lead.dealType} />
            <DetailItem icon={Calendar} label="Go-Live Date" value={lead.targetGoLiveDate} />
            <DetailItem icon={Info} label="Company Size" value={lead.companySize} />
            <DetailItem icon={Info} label="Sales Region" value={lead.salesRegionTerritory} />
            <DetailItem icon={lead.soc2 ? CheckSquare : XSquare} label="SOC2 Required" value={lead.soc2 ? 'Yes' : 'No'} />
            <DetailItem icon={Info} label="Notes" value={<p className="whitespace-pre-wrap">{lead.notes}</p>} />
          </dl>
        </div>

        <div className="lg:col-span-1 space-y-6">
            <div className="bg-white p-6 rounded-lg shadow-sm">
                <h3 className="font-semibold text-gray-900 mb-4">Timeline</h3>
                <p className="text-sm text-gray-500">Activity feed coming soon.</p>
            </div>
        </div>
      </div>
    </div>
  );
};

export default LeadDetail;
